import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class VersionService {
  urlService: string;
  constructor(private http: HttpClient, config: ConfigService) {
    this.urlService = config.values.api_url
   }

  getApiVersionNumber() {
    return this.http.get(this.urlService + 'api/version/GetVersion').pipe(
      map(val => {
        return val
      }),
      catchError(error => {
        return of(error);
      })
    );
  }
}
